import styled, { css } from "styled-components";
import { Grid, TextField } from "@mui/material";
import { Title } from "src/modules/order/shipping-order/components";

const TextFieldStyled = styled(TextField)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #f3f1f2;
      border-radius: 16px;
    `}
`;

const Note = ({ info }) => {
  return (
    <Grid container xs={12}>
      <Title>โน๊ต</Title>

      <Grid item xs={12} mt={2}>
        <TextFieldStyled
          fullWidth
          placeholder="โน๊ต"
          rows={4}
          multiline
          disabled
          value={info?.internalNote ?? "-"}
        />
      </Grid>
    </Grid>
  );
};

export default Note;
